import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { DATA_SYNC_OPTIONS, DataSyncOptionAppsConfigs } from '../constants/dataSyncConstants';
import { CONNECT_APPS_OPTIONS } from '../constants/connectAppConstants';
import { DataSyncOptionApp } from '../constants/types';
import { jsx as _jsx } from "react/jsx-runtime";
export const getIsDataSyncOption = app => {
  return Object.entries(DATA_SYNC_OPTIONS).some(([optionId, {
    url
  }]) => {
    // Data Sync apps are handled by this modal, and have no external URLs
    const hasNoUrl = !url;
    return optionId === app && hasNoUrl;
  });
};
export const getPageTitleForApp = app => {
  switch (app) {
    case DataSyncOptionApp.Gmail:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "growthDataModal.connectApp.header.title.googleContacts"
      });
    case DataSyncOptionApp.Outlook:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "growthDataModal.connectApp.header.title.outlookContacts"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "growthDataModal.connectApp.header.title.default"
      });
  }
};
export const getAppIdForDataSyncApp = app => DataSyncOptionAppsConfigs[app].appId;
export const getDataSyncUrlSearchParamsForApp = app => CONNECT_APPS_OPTIONS[app].dataSyncUrlSearchParams || [];
export const clearAllAlerts = () => {
  Object.keys(FloatingAlertStore.getAlerts()).forEach(alertId => FloatingAlertStore.removeAlert(alertId));
};
export const showSyncSuccessAlert = () => {
  clearAllAlerts();
  FloatingAlertStore.addAlert({
    type: 'success',
    titleText: I18n.text('growthDataModal.oneClickSync.alerts.google-contacts.success.title'),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "growthDataModal.oneClickSync.alerts.google-contacts.success.message"
    }),
    sticky: true
  });
};
const getSyncFailTitleText = errorType => {
  switch (errorType) {
    case 'OAuthWindowBlocked':
      return I18n.text('growthDataModal.oneClickSync.alerts.google-contacts.failure.OAuthWindowBlocked.title');
    case 'OAuthWindowClosed':
      return I18n.text('growthDataModal.oneClickSync.alerts.google-contacts.failure.OAuthWindowClosed.title');
    case 'OAuthWindowTimeout':
      return I18n.text('growthDataModal.oneClickSync.alerts.google-contacts.failure.OAuthWindowTimeout.title');
    case 'MissingPermissions':
      return I18n.text('growthDataModal.oneClickSync.alerts.google-contacts.failure.MissingPermissions.title');
    case 'DuplicateDataSyncAccount':
      return I18n.text('growthDataModal.oneClickSync.alerts.google-contacts.failure.DuplicateDataSyncAccount.title');
    default:
      return I18n.text('growthDataModal.oneClickSync.alerts.google-contacts.failure.generic.title');
  }
};
const getSyncFailMessage = errorType => {
  switch (errorType) {
    case 'OAuthWindowBlocked':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "growthDataModal.oneClickSync.alerts.google-contacts.failure.OAuthWindowBlocked.message"
      });
    case 'OAuthWindowClosed':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "growthDataModal.oneClickSync.alerts.google-contacts.failure.OAuthWindowClosed.message"
      });
    case 'OAuthWindowTimeout':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "growthDataModal.oneClickSync.alerts.google-contacts.failure.OAuthWindowTimeout.message"
      });
    case 'MissingPermissions':
      return I18n.text('growthDataModal.oneClickSync.alerts.google-contacts.failure.MissingPermissions.message');
    case 'DuplicateDataSyncAccount':
      return I18n.text('growthDataModal.oneClickSync.alerts.google-contacts.failure.DuplicateDataSyncAccount.message');
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "growthDataModal.oneClickSync.alerts.google-contacts.failure.generic.message"
      });
  }
};
export const showSyncFailureAlert = errorType => {
  clearAllAlerts();
  FloatingAlertStore.addAlert({
    type: 'danger',
    titleText: getSyncFailTitleText(errorType),
    message: getSyncFailMessage(errorType)
  });
};
export const waitFor = delayMs => {
  return new Promise(resolve => {
    setTimeout(resolve, delayMs);
  });
};